import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { delay, Observable, of, throwError } from 'rxjs';
import { MOCK_ROUTES } from './mock-routes';
import { MockHttpError, MockMethod, MockRequest, MockRoute } from './mock-api';

/** Latência simulada, para os skeletons e loadings do Hub aparecerem */
const MOCK_LATENCY_MS = 350;

/**
 * Responde as chamadas HTTP do código do Hub com dados mock (o protótipo não tem backend).
 * URLs absolutas (assets, PDFs de exemplo) passam direto.
 */
export const mockApiInterceptor: HttpInterceptorFn = (req, next) => {
	if (/^https?:\/\//i.test(req.url) || req.url.startsWith('./') || req.url.startsWith('assets/')) {
		return next(req);
	}

	const path = req.url.split('?')[0];
	const match = findRoute(req.method as MockMethod, path);

	if (!match) {
		console.warn(`[mock-api] sem mock para ${req.method} ${path}`);
		return fail(
			req.url,
			new MockHttpError(404, 'Não encontrado', `Sem mock para ${req.method} ${path}`),
		);
	}

	const request: MockRequest = {
		method: req.method as MockMethod,
		path,
		params: match.params,
		query: req.params,
		body: req.body,
	};

	try {
		const body = match.route.handle(request);
		return of(new HttpResponse({ status: 200, body, url: req.url })).pipe(delay(MOCK_LATENCY_MS));
	} catch (error) {
		if (error instanceof MockHttpError) return fail(req.url, error);
		throw error;
	}
};

function fail(url: string, error: MockHttpError): Observable<never> {
	const response = new HttpErrorResponse({
		status: error.status,
		url,
		error: { status: error.status, title: error.title, detail: error.detail },
	});
	return throwError(() => response).pipe(delay(MOCK_LATENCY_MS));
}

function findRoute(method: MockMethod, path: string) {
	for (const route of MOCK_ROUTES) {
		if (route.method !== method) continue;
		const params = matchPath(route, path);
		if (params) return { route, params };
	}
	return null;
}

function matchPath(route: MockRoute, path: string): Record<string, string> | null {
	const routeParts = route.path.split('/').filter(Boolean);
	const pathParts = path.split('/').filter(Boolean);
	if (routeParts.length !== pathParts.length) return null;

	const params: Record<string, string> = {};
	for (let index = 0; index < routeParts.length; index++) {
		const routePart = routeParts[index];
		if (routePart.startsWith(':'))
			params[routePart.slice(1)] = decodeURIComponent(pathParts[index]);
		else if (routePart !== pathParts[index]) return null;
	}
	return params;
}
